export const sliderImages = [
    "https://dkpdw0r5j9hhy.cloudfront.net/interstitial/letter-value-props/web/your-message.png",
    "https://dkpdw0r5j9hhy.cloudfront.net/interstitial/letter-value-props/web/stationery.png",
    "https://dkpdw0r5j9hhy.cloudfront.net/interstitial/letter-value-props/web/envelopes.png",
    "https://dkpdw0r5j9hhy.cloudfront.net/interstitial/letter-value-props/web/tracking.png",
    "https://dkpdw0r5j9hhy.cloudfront.net/interstitial/letter-value-props/web/go-premium.png",
];
